module.exports = __webpack_public_path__ + "img/banner.c89b94e4.svg";